<style scoped>
    .label{
        display: inline-block;
        vertical-align: middle;
        width: 60px;
    }
    .drawer-wrapper {
        z-index: 10!important
    }
</style>
<template>
  <div>
    <Drawer
      v-model="config.modal"
      class-name="drawer-wrapper"
      width="640"
      title="工资汇总导出"
    >
      <div class="line">
        <span class="label">日期范围: </span>
        <DatePicker
          type="month"
          split-panels
          placeholder="Select Month"
          style="width: 200px"
          @on-change="monthChange"
        />
      </div>
      <div class="line">
        <Button
          long 
          type="primary" 
          icon="md-download" 
          :loading="loading"
          @click="exportResource"
        >
          导出
        </Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
  import {getExportWageRecordApi} from '../service'
  export default {
    data() {
      return {
        config: {
          modal: false
        },
        loading: false,
        params: {
          month: ''
        }
      }
    },
    computed: {
      //
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      show() {
        this.config.modal = true;
      },
      monthChange(month) {
        this.params.month = month;
      },
      checkValid() {
        if (!this.params.month) {
          this.$Modal.warning({title: '提示', content: '请选择导出月份'});
          return false;
        }
        return true;
      },
      exportResource() {
        if (!this.checkValid()) return;
        if (this.loading) return;
        this.loading = true;
        getExportWageRecordApi(this.params || {}).then(() => {
          this.config.modal = false;
          this.$emit("done");
        }).catch((msg) => {
          this.$Modal.warning({title: '错误', content: msg});
        }).finally(() => {
          this.loading = false;
        })
        // Util.ajax.get(Util.api.export_wage_record, {
        //   params: this.params
        // }).then((response) => {
        //   return response.data;
        // }).then((res) => {
        //   console.log(res);
        //   if (res.code === 1) {
        //     this.config.modal = false;
        //     this.$emit("done");
        //   } else {
        //     this.$Modal.warning({title: '错误', content: res.msg});
        //   }
        // }).catch((e) => {
        //   console.log(e);
        //   this.$Modal.warning({title: '错误', content: e.message});
        // }).finally(() => {
        //   this.loading = false;
        // });
      }
    }
  }
</script>
